import { createAction } from '@reduxjs/toolkit';
import { RequestLoginLocal, RequestOauth2AllowDevice } from '../../interfaces/request';
import { TimeEventQueryPopulate } from '@kalyzee/kast-web-sdk/http';

export const requestLoginLocal = createAction<RequestLoginLocal>('request_login_local');
export const requestLogout = createAction('request_logout');
export const requestGetMe = createAction('request_getme');
export const requestSocketToken = createAction('request_socket_token');
export const requestOauth2AllowDevice = createAction<RequestOauth2AllowDevice>('request_oauth2_allow_device');
export const requestGetRoom = createAction<{ roomId: string }>('request_get_room');
export const requestGetTimeEvents = createAction<{ room?: string, beforeDate?: Date, afterDate?: Date, populate?: TimeEventQueryPopulate[], meetingFilter?: {ids?: string[]} }>('request_get_time_events');

const requestActions = {
  requestLoginLocal,
  requestLogout,
  requestGetMe,
  requestSocketToken,
  requestOauth2AllowDevice,
  requestGetRoom,
  requestGetTimeEvents,
}

export default requestActions;
